export const setMessage = (message: string) => ({
  type: "SET_MESSAGE",
  payload: message,
});

